module.exports = __webpack_public_path__ + "img/44.51b25d43.svg";